import { render, staticRenderFns } from "./client-select-modal.vue?vue&type=template&id=54149b68"
import script from "./client-select-modal.vue?vue&type=script&lang=js"
export * from "./client-select-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports